<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Izaberi prevoznika</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
             <app-transporter-autocomplete [transporter]="transporter" (selected)="onSelectTransporter($event)"></app-transporter-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()">Potvrdi</button>
    </div>
  </div>
</div>